import type { Hit } from 'instantsearch.js'
import type { AlgoliaTrialHit } from '../const'
interface GeoJSONFeature {
  geometry: {
    coordinates: [number, number]
    type: 'Point'
  }
  id: number
  properties: {
    id: string
    nctId: string
  }
  type: 'Feature'
}

interface GeoJSONFeatureCollection {
  features: GeoJSONFeature[]
  type: 'FeatureCollection'
}

/**
 * Converts an array of AlgoliaTrialHit items into a GeoJSON FeatureCollection.
 */
export default function transformAlgoliaHitsToGeoJSON(
  items: Hit<AlgoliaTrialHit>[],
): GeoJSONFeatureCollection {
  const features = items
    .map((item, index) => {
      // Guard: if _geoloc is undefined or empty, skip this item
      if (!item._geoloc || !item._geoloc[0]) {
        return null
      }
      const { lat, lng } = item._geoloc[0]
      return {
        geometry: {
          coordinates: [lng, lat] as [number, number],
          type: 'Point',
        },
        id: index,
        properties: {
          id: item.objectID,
          nctId: item.nctId,
        },
        type: 'Feature',
      }
    })
    .filter((feature): feature is GeoJSONFeature => feature !== null)

  return {
    features,
    type: 'FeatureCollection',
  }
}
